export const chartColors = [
  '#0758b7', // SSD PRIMARY
  '#347f38', // GREEN
  '#9060f0',
  '#b34ab0',
  '#e0439a',
  '#ff497c',
  '#ff615b',
  '#ff8337',
  '#ffa600',
  '#ba6207',
  '#5f1ae9',
  '#c1a6f7',
  '#6d97c7'
];